<template>
  <div>
    <v-alert type="success" :value="renderSuccess">
      <div v-for="(message, idx) in successMessage" :key="idx">
        {{message.message}}
      </div>
    </v-alert>
    <v-alert type="info" :value="renderInfo">
      <div v-for="(message, idx) in infoMessage" :key="idx">
        {{message.message}}
      </div>
    </v-alert>

    <v-alert type="warning" :value="renderWarn">
      <div v-for="(message, idx) in warnMessage" :key="idx">
        {{message.message}}
      </div>
    </v-alert>

    <v-alert type="error" :value="renderError">
      <div v-for="(message, idx) in errorMessage" :key="idx">
        {{message.message}}
      </div>
    </v-alert>
  </div>
</template>

<script>
import { msgTypes } from '@/const'

const { INFO, WARN, ERROR, SUCCESS } = msgTypes

export default {
  computed: {
    infoMessage() {
      return this.messages.filter((message) => {
        return message.type === INFO
      })
    },
    warnMessage() {
      return this.messages.filter((message) => {
        return message.type === WARN
      })
    },
    errorMessage() {
      return this.messages.filter((message) => {
        return message.type === ERROR
      })
    },
    successMessage() {
      return this.messages.filter((message) => {
        return message.type === SUCCESS
      })
    },
    renderInfo() {
      if (this.infoMessage.length > 0) {
        return true
      } else {
        return false
      }
    },
    renderWarn() {
      if (this.warnMessage.length > 0) {
        return true
      } else {
        return false
      }
    },
    renderError() {
      if (this.errorMessage.length > 0) {
        return true
      } else {
        return false
      }
    },
    renderSuccess() {
      if (this.successMessage.length > 0) {
        return true
      } else {
        return false
      }
    }
  },
  props: {
    messages: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style>

</style>
